export function startVersionWatcher(options = {}) {
  const {
    checkIntervalMs = 300000, // 5 minutes
    versionUrl = '/version.json',
    storageKey = 'APP_BUILD_VERSION',
  } = options;

  let timerId = null;
  let isChecking = false;

  async function fetchVersion() {
    const url = `${versionUrl}?_=${Date.now()}`;
    try {
      const response = await fetch(url, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      });
      if (!response.ok) return null;
      const data = await response.json();
      return String(data.version || '');
    } catch (err) {
      return null;
    }
  }

  async function checkAndReloadIfNeeded() {
    if (isChecking) return;
    isChecking = true;
    try {
      const latestVersion = await fetchVersion();
      if (!latestVersion) return;
      const currentVersion = localStorage.getItem(storageKey) || '';
      if (!currentVersion) {
        localStorage.setItem(storageKey, latestVersion);
        return;
      }
      if (currentVersion && latestVersion && latestVersion !== currentVersion) {
        try {
          localStorage.setItem(storageKey, latestVersion);
        } catch (_) {}
        const hasQuery = window.location.search && window.location.search.length > 0;
        const cacheBuster = `${hasQuery ? '&' : '?'}_v=${Date.now()}`;
        const newHref = `${window.location.origin}${window.location.pathname}${window.location.search}${cacheBuster}${window.location.hash}`;
        window.location.replace(newHref);
      }
    } finally {
      isChecking = false;
    }
  }

  async function init() {
    const initial = await fetchVersion();
    if (initial) {
      try {
        localStorage.setItem(storageKey, initial);
      } catch (_) {}
    }

    if (checkIntervalMs > 0) {
      timerId = window.setInterval(checkAndReloadIfNeeded, checkIntervalMs);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        checkAndReloadIfNeeded();
      }
    });

    window.addEventListener('focus', () => {
      checkAndReloadIfNeeded();
    });
  }

  init();

  return () => {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
  };
} 